/* unplugin-vue-components disabled */import { render } from "./topic-search.vue?vue&type=template&id=6d636122&scoped=true"
import script from "./topic-search.vue?vue&type=script&lang=js"
export * from "./topic-search.vue?vue&type=script&lang=js"

import "./topic-search.vue?vue&type=style&index=0&id=6d636122&lang=stylus"
import "./topic-search.vue?vue&type=style&index=1&id=6d636122&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d636122"],['__file',"src/components/search-dropdown/topic-search.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d636122"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d636122', __exports__)) {
    api.reload('6d636122', __exports__)
  }
  
  module.hot.accept("./topic-search.vue?vue&type=template&id=6d636122&scoped=true", () => {
    api.rerender('6d636122', render)
  })

}


export default __exports__